import {KeyboardListener} from "../../../../../../utils/interaction/key/KeyboardListener";

export const isUserTryingToPutItOnTopOfHoveredItems = (): boolean => {
	return KeyboardListener.isShiftDown;
};
